import Hero from './components/Hero';
import BioRapida from './components/BioRapida';
import ProcessoTransformacao from './components/ProcessoTransformacao';
import ResultadosNumeros from './components/ResultadosNumeros';
import Conceito from './components/Conceito';
import ParaQuemE from './components/ParaQuemE';
import ComoFunciona from './components/ComoFunciona';
import Beneficios from './components/Beneficios';
import EscritaCarta from './components/EscritaCarta';
import CadernoGratidao from './components/CadernoGratidao';
import MeditacaoGuiada from './components/MeditacaoGuiada';
import ExperienciasComplementares from './components/ExperienciasComplementares';
import ExerciciosPNLGamificados from './components/ExerciciosPNLGamificados';
import TestesInstagram from './components/TestesInstagram';
import JornadaMetodo from './components/JornadaMetodo';
import AntesDepois from './components/AntesDepois';
import ProvaSocial from './components/ProvaSocial';
import DepoimentosTransformacao from './components/DepoimentosTransformacao';
import VideoDepoimentosHome from './components/VideoDepoimentosHome';
import VitoriasSection from './components/VitoriasSection';
import ComparacaoPlanos from './components/ComparacaoPlanos';
import FAQHome from './components/FAQHome';
import CTAFinal from './components/CTAFinal';
import Footer from './components/Footer';
import Navbar from './components/Navbar';
import CTASticky from '../../components/feature/CTASticky';
import SEOHead from '../../components/feature/SEOHead';
import { useEffect } from 'react';
import ExitIntentPopup from './components/ExitIntentPopup';

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://example.com';

const homeSchema = [
  {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'Carta do Eu Futuro',
    url: SITE_URL,
    description: 'Plataforma de desenvolvimento pessoal com PNL, gratidão e técnicas de transformação.',
    inLanguage: 'pt-BR',
    potentialAction: {
      '@type': 'SearchAction',
      target: {
        '@type': 'EntryPoint',
        urlTemplate: `${SITE_URL}/blog?q={search_term_string}`,
      },
      'query-input': 'required name=search_term_string',
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'Carta do Eu Futuro',
    url: SITE_URL,
    logo: `${SITE_URL}/logo.png`,
    sameAs: [
      'https://www.instagram.com/bia.holmes',
    ],
    founder: {
      '@type': 'Person',
      name: 'Bia Holmes',
      jobTitle: 'Especialista em Transformação Pessoal e PNL',
    },
    description: 'Plataforma completa de desenvolvimento pessoal com exercícios de PNL, meditações guiadas, caderno de gratidão digital e técnicas de transformação.',
    address: {
      '@type': 'PostalAddress',
      addressCountry: 'BR',
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: 'Como a PNL pode transformar minha vida profissional e financeira?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'A PNL reprograma padrões mentais limitantes que bloqueiam seu sucesso. Através de técnicas como ancoragem de poder, ressignificação e técnica Swish, você elimina crenças sabotadoras e instala novos comportamentos de alta performance.',
        },
      },
      {
        '@type': 'Question',
        name: 'Preciso ter experiência prévia com PNL ou meditação?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Não! Nosso método foi desenhado para todos os níveis. Começamos com exercícios básicos gratuitos para você experimentar sem compromisso.',
        },
      },
      {
        '@type': 'Question',
        name: 'Posso cancelar minha assinatura a qualquer momento?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Sim, você pode cancelar a qualquer momento sem burocracia. Oferecemos garantia de 7 dias com devolução de 100% do investimento.',
        },
      },
    ],
  },
];

export default function HomePage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-[#0a0a0a]">
      <SEOHead
        title="Método Bia Holmes | Reprogramação Mental para Mulheres Líderes"
        description="Reprogramação mental de alta performance para executivas, empresárias e profissionais liberais que querem quebrar padrões internos e alcançar o próximo nível. Baseado em PNL clínica."
        keywords="reprogramação mental, PNL mulheres líderes, desenvolvimento pessoal executivas, Bia Holmes, alta performance, técnicas PNL"
        canonical="/"
        ogImage="https://public.readdy.ai/ai/img_res/4af372fc16b978ebad28454268cad03c.jpg"
        ogType="website"
        schema={homeSchema}
      />
      <ExitIntentPopup />
      <Navbar />

      <Hero />
      <BioRapida />
      <ProcessoTransformacao />
      <ResultadosNumeros />
      <ParaQuemE />
      <Conceito />
      <ComoFunciona />
      <Beneficios />
      <EscritaCarta />
      <CadernoGratidao />
      <MeditacaoGuiada />
      <ExperienciasComplementares />
      <ExerciciosPNLGamificados />
      <TestesInstagram />
      <JornadaMetodo />
      <AntesDepois />
      <ProvaSocial />
      <DepoimentosTransformacao />
      <VideoDepoimentosHome />
      <VitoriasSection />
      <ComparacaoPlanos />
      <FAQHome />
      <CTAFinal />
      <Footer />
      <CTASticky />
    </div>
  );
}
